// extracted by mini-css-extract-plugin
export var cardIcon = "_7t-5";
export var cardIconUnframed = "_7t-9";
export var checkboxCard = "_7t-0";
export var checkboxCardSelected = "_7t-4";
export var disabled = "_7t-2";
export var interactive = "_7t-1";
export var outerBorder = "_7t-3";
export var spacerMedium = "_7t-8";
export var spacerSmall = "_7t-7";
export var spacerXsmall = "_7t-6";